<template>
  <!-- <div class="test1209 ldBar label-center" data-type="fill" data-img="https://private.autoturn.net/autoturn_logo_v04.svg" style="width:300px;height:300px;" ></div> -->
  <loading :active="releaseType"
            :can-cancel="true"
            :is-full-page="true"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :style="style">
            <!-- <div class="text-center text-blue-50 text-4xl" style="background-color:red;word-wrap:break-word; width:300px;">建立關鍵字...</div>
            <div class="w-2/4" style="background-color:blue;display: flex; justify-content: center; align-items: center; width:300px; ">
              <div style="margin: auto"> -->
                <!-- <circle-progress :percent="releasePercent" :show-percent="true" :class="'text-blue-50 text-4xl'"/> -->
                <div id="releaseFill" class="ldBar label-center" data-type="fill" data-img="https://private.autoturn.net/autoturn_logo_v04.svg" style="width:300px;height:300px;" ></div>
              <!-- </div>
            </div> -->
  </loading>
  <loading 
          v-if="allPageLoading"
          :active="allPageLoading"
          :can-cancel="true"
          :on-cancel="onCancel"
          :is-full-page="true"
          :color="'#fff'"
          :background-color="'#000'"
          :opacity="'0.8'"
          :loader=" dots">
  </loading>
  <div class="d2-list-table-card" style="height:auto;">
    <loading :active="!showTable"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="false"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <DataTable
      :value="records"
      :paginator="true"
      class="p-datatable-customers"
      :rows="10"
      dataKey="id"
      :rowHover="true"
      v-model:filters="filters"
      filterDisplay="menu"
      :loading="loading"
      paginatorTemplate="CurrentPageReport RowsPerPageDropdown PrevPageLink PageLinks NextPageLink"
      :rowsPerPageOptions="[10,25,50]"
      :currentPageReportTemplate="`${lang['components']['List']['ListDataTable']['datatable_page_info']}`"
      :globalFilterFields="['campaign_name','status','report','active','updatedDate','pageInfo']"
      responsiveLayout="scroll"
      @page="onPageCange($event)"
    >
      <!-- Header -->
      <template #header class="bg-white">
        <div class="d2-list-search-bar">
          <i class="fas fa-search"></i>
          <InputText v-model="filters['global'].value" placeholder="Keyword Search" class="w-full" />
        </div>
      </template>

      <template #empty>
        No records found.
      </template>

      <template #loading>
        Loading records data. Please wait.
      </template>

      <Column field="campaign_name" :header="`${lang['components']['List']['ListDataTable']['field_a']}`" sortable style="min-width: 10rem">
        <template #body="{data}">
          <span class="data-txt">{{ data.campaign_name }}</span>
        </template>
        <!--<template #filter="{filterModel}">
          <InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Search by name" />
        </template>-->
      </Column>

      <Column field="status" :header="`${lang['components']['List']['ListDataTable']['field_b']}`" sortable style="min-width: 10rem">
        <template #body="{data}">
          <div class="d2-list-status-cell">
            <span class="d2-list-status-tag official" v-if="data.status === '正式' || data.status === 'official'">
              {{ data.status }}
            </span>
            <span class="d2-list-status-tag required" v-else-if="data.status && (data.status.includes('必填欄位未填齊') || data.status.includes('必填栏位未填齐') || data.status.includes('Required field not filled'))">
              {{ data.status.includes('必填欄位未填齊') ? '必填欄位未填齊' : (data.status.includes('必填栏位未填齐') ? '必填栏位未填齐' : 'Required field not filled') }}
            </span>
            <span class="d2-list-status-tag expired" v-else-if="(data.status === '草稿' || data.status === 'draft' || data.status === 'Draft') && (data.isActive === '已過期' || data.isActive === '已过期' || data.isActive === 'expired' || data.isActive === 'Expired')">
              {{ lang['components']['List']['ListDataTable']['is_expired'] }}
            </span>
            <span class="d2-list-status-tag green" v-else>
              {{ data.status }}
            </span>
            <span class="d2-list-sub-status" :class="data.isActive === '投放中' || data.isActive === '投放中' || data.isActive === 'Active' ? 'active' : 'paused'" v-if="data.status === '正式' || data.status === 'official'">
              {{ data.isActive }}
            </span>
            <i v-if="data.error_info != ''"
              class="fas fa-exclamation-circle d2-list-err-icon"
              v-tooltip.top="`${data.error_info}`"
            ></i>
            <i v-else-if="data.paused_log != ''"
              class="fas fa-exclamation-circle d2-list-warn-icon"
              v-tooltip.top="`${data.paused_log}`"
            ></i>
          </div>
        </template>
      </Column>

      <Column field="report" :header="`${lang['components']['List']['ListDataTable']['field_c']}`" sortable style="min-width: 10rem">
        <template #body="{data}">
          <div class="flex items-center" v-if="data.report != '尚未產生報表' && data.report != 'Report not yet generated'">
            <span class="d2-list-report-flag good"></span>
            <span class="d2-list-report-link" @click="handleClickOpen($event, data.id, data.isActive, data.adaccount_id)"><i class="fas fa-chart-line"></i>{{ data.report }}</span>
          </div>
          <span class="d2-list-report-none" v-else>{{ data.report }}</span>
        </template>
      </Column>

      <Column field="active" :header="`${lang['components']['List']['ListDataTable']['field_d']}`" style="min-width: 14rem">
        <template #body="{data}">
          <div class="d2-list-action-btns">
            <div v-for="(item, idx) in data.actions" :key="idx">
              <ActionIcon :type="item.type" v-tooltip="item.name" @click="campaignActive(data.id, item.type, data.daily_budget, data.budget_increase, data.campaign_name, data.adaccount_id, data.total_budget, data.Target_AD, data.Target_CT, data.sub_campaigns)" />
            </div>
          </div>
        </template>
      </Column>

      <Column field="updatedDate" :header="`${lang['components']['List']['ListDataTable']['field_e']}`" sortable style="min-width: 10rem">
        <template #body="{data}">
          <span class="data-txt">{{ data.updatedDate }}</span>
          <!-- <br />
          <span class="small-txt">{{ data.updatedTime }}</span> -->

        </template>
      </Column>

      <Column field="pageInfo" :header="`${lang['components']['List']['ListDataTable']['field_f']}`" style="min-width: 14rem">
        <template #body="{data}">
          <span class="data-txt">{{ data.event_name }}</span><br />
          <span class="small-txt">{{ data.ads_count_list }}</span>
        </template>
      </Column>

    </DataTable>
    <OverlayPanel
      ref="previewPanel"
      appendTo="body"
      id="overlay_panel"
      :breakpoints="{'960px': '75vw'}"
      class="rounded-xl"
    >
      <div v-if="!fin">{{lang['components']['List']['ListDataTable']['report_loading_text']}}...</div>
      <h1 v-if="fin" class="overpanel-title">
        {{lang['components']['List']['ListDataTable']['report_loading_title']}}
      </h1>

      <div v-if="fin" class="close-btn" @click="toggle">
        <span class="p-overlaypanel-close-icon pi pi-times"></span>
      </div>

      <div v-if="fin">
        <PanelChart :chartsData="lineStylesData" :tableData="tableData" :title="label" v-bind:chartCampaignId="chartCampaignId" v-bind:chartCampaignAdaccountId="chartCampaignAdaccountId" v-bind:lang="lang" />
      </div>

    </OverlayPanel>
  </div>
</template>

<script>

import OverlayPanel from 'primevue/overlaypanel'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
import ActionIcon from './ActionIcon.vue';
import { FilterMatchMode, FilterOperator } from "primevue/api"
import PanelChart from '@/components/List/PanelChart.vue'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import "vue3-circle-progress/dist/circle-progress.css";
import CircleProgress from "vue3-circle-progress";
import axios from 'axios'
import Qs from 'qs'

export default {
  name: 'ListDataTable',
  components: {
    DataTable,
    Column,
    InputText,
    ActionIcon,
    OverlayPanel,
    PanelChart,
    Loading,
    CircleProgress
  },
  props: {
    showTable: {
      type: Boolean
    },
    viewDatalist: {
      type: Object,
      default: () => []
    },
    selecdedCurrency: {
      type: String
    },
    fromAccountSelect: {
      type: String
    },
    parentMemberInfo: {
      type: Object,
      default: () => []
    },
    lang: {
      type: Object
    },
  },
  data() {
    return {
      fin: false,
      chartCampaignId: null,
      chartCampaignAdaccountId: null,
      allPageLoading: false,
      releaseType: true,
      style: 'z-index: -1;',
      releaseText: '發佈中...',
      releasePercent: 5,
      label:[
"CTR（連結點擊率）",
"CPC（單次連結點擊成本）",
"轉換率（購買/連擊點擊次數）",
"CPA（每次購買的成本）"
],
      // tableData: [
      //   {
      //     since: "2021-03-11",
      //     title: "網頁轉換表現不佳，建議優化網頁內容或是增強與廣告關聯性",
      //     until: "2021-03-11",
      //     since_value: 3.0364372469636,
      //     until_value: 0.95785440613027,
      //     since_index: 6,
      //     until_index: 9,
      //     data_key: "data1"
      //   },
      //   {
      //     since: "2021-05-04",
      //     title: "網頁轉換表現不佳，建議優化網頁內容或是增強與廣告關聯性",
      //     until: "2021-05-07",
      //     since_value: 3.0364372469636,
      //     until_value: 0.95785440613027,
      //     since_index: 6,
      //     until_index: 9,
      //     data_key: "data1"
      //   }
      // ],
      tableData: [
[
{
since: "2020-07-24",
title: "廣告素材呈現疲乏，建議更換新的創意內容",
until: "2020-07-27",
borderColor: "#B6BDE7"
},
{
since: "2021-01-11",
title: "廣告素材呈現疲乏，建議更換新的創意內容",
until: "2021-01-14",
borderColor: "#B6BDE7"
},
{
since: "2021-02-26",
title: "廣告素材呈現疲乏，建議更換新的創意內容",
until: "2021-03-01",
borderColor: "#B6BDE7"
},
{
since: "2021-08-15",
title: "廣告素材呈現疲乏，建議更換新的創意內容",
until: "2021-08-19",
borderColor: "#B6BDE7"
}
],
[
{
since: "2020-07-24",
title: "廣告素材呈現疲乏，建議更換新的創意內容",
until: "2020-07-27",
borderColor: "#B6BDE7"
},
{
since: "2020-11-02",
title: "廣告素材呈現疲乏，建議更換新的創意內容",
until: "2020-11-05",
borderColor: "#B6BDE7"
},
{
since: "2021-01-11",
title: "廣告素材呈現疲乏，建議更換新的創意內容",
until: "2021-01-15",
borderColor: "#B6BDE7"
},
{
since: "2021-02-02",
title: "廣告素材呈現疲乏，建議更換新的創意內容",
until: "2021-02-05",
borderColor: "#B6BDE7"
},
{
since: "2021-02-09",
title: "廣告素材呈現疲乏，建議更換新的創意內容",
until: "2021-02-12",
borderColor: "#B6BDE7"
},
{
since: "2021-05-30",
title: "廣告素材呈現疲乏，建議更換新的創意內容",
until: "2021-06-02",
borderColor: "#B6BDE7"
},
{
since: "2021-08-15",
title: "廣告素材呈現疲乏，建議更換新的創意內容",
until: "2021-08-19",
borderColor: "#B6BDE7"
},
{
since: "2021-09-20",
title: "廣告素材呈現疲乏，建議更換新的創意內容",
until: "2021-09-25",
borderColor: "#B6BDE7"
}
],
[
{
since: "2020-07-29",
title: "網頁轉換表現不佳，建議優化網頁內容或是增強與廣告關聯性",
until: "2020-08-02",
borderColor: "#B6BDE7"
},
{
since: "2020-08-12",
title: "網頁轉換表現不佳，建議優化網頁內容或是增強與廣告關聯性",
until: "2020-08-16",
borderColor: "#B6BDE7"
},
{
since: "2020-08-30",
title: "網頁轉換表現不佳，建議優化網頁內容或是增強與廣告關聯性",
until: "2020-09-02",
borderColor: "#B6BDE7"
},
{
since: "2020-12-25",
title: "網頁轉換表現不佳，建議優化網頁內容或是增強與廣告關聯性",
until: "2020-12-28",
borderColor: "#B6BDE7"
},
{
since: "2021-01-11",
title: "網頁轉換表現不佳，建議優化網頁內容或是增強與廣告關聯性",
until: "2021-01-14",
borderColor: "#B6BDE7"
},
{
since: "2021-01-25",
title: "網頁轉換表現不佳，建議優化網頁內容或是增強與廣告關聯性",
until: "2021-01-28",
borderColor: "#B6BDE7"
},
{
since: "2021-02-01",
title: "網頁轉換表現不佳，建議優化網頁內容或是增強與廣告關聯性",
until: "2021-02-04",
borderColor: "#B6BDE7"
},
{
since: "2021-02-08",
title: "網頁轉換表現不佳，建議優化網頁內容或是增強與廣告關聯性",
until: "2021-02-11",
borderColor: "#B6BDE7"
},
{
since: "2021-02-18",
title: "網頁轉換表現不佳，建議優化網頁內容或是增強與廣告關聯性",
until: "2021-02-22",
borderColor: "#B6BDE7"
},
{
since: "2021-07-10",
title: "網頁轉換表現不佳，建議優化網頁內容或是增強與廣告關聯性",
until: "2021-07-14",
borderColor: "#B6BDE7"
},
{
since: "2021-09-05",
title: "網頁轉換表現不佳，建議優化網頁內容或是增強與廣告關聯性",
until: "2021-09-08",
borderColor: "#B6BDE7"
},
{
since: "2021-09-13",
title: "網頁轉換表現不佳，建議優化網頁內容或是增強與廣告關聯性",
until: "2021-09-17",
borderColor: "#B6BDE7"
}
],
[ ]
],
      // lineStylesData: {
      //   datasets: [
      //     {
      //       data: [
      //         {
      //           x: new Date('2021/02/15'),
      //           y: 11
      //         },
      //         {
      //           x: new Date('2021/03/15'),
      //           y: 30
      //         },
      //         {
      //           x: new Date('2021/04/04'),
      //           y: 46
      //         },
      //         {
      //           x: new Date('2021/05/04'),
      //           y: 66
      //         },
      //         {
      //           x: new Date('2021/07/11'),
      //           y: 82
      //         }
      //       ],
      //       //pointRadius: 0,
      //       fill: true,
      //       borderColor: '#FADB76',
      //       backgroundColor: 'rgba(250, 219, 118, 0.3)',
      //       tension: .4,
      //     },
      //     {
      //       data: [
      //         {
      //           x: new Date('2021/02/15'),
      //           y: 22
      //         },
      //         {
      //           x: new Date('2021/03/15'),
      //           y: 13
      //         },
      //         {
      //           x: new Date('2021/04/04'),
      //           y: 54
      //         },
      //         {
      //           x: new Date('2021/05/04'),
      //           y: 76
      //         },
      //         {
      //           x: new Date('2021/07/11'),
      //           y: 102
      //         }
      //       ],
      //       //pointRadius: 0,
      //       fill: true,
      //       borderColor: '#72B6F4',
      //       backgroundColor: 'rgba(114, 182, 244, 0.2)',
      //       tension: .4,
      //     },
      //   ],
      // },
      lineStylesData: [
{
datasets: [
{
label: "精準興趣-比率（%）",
data: [
{
x: "Tue, 21 Sep 2021 00:00:00 +0000",
y: 0.6
},
{
x: "Wed, 22 Sep 2021 00:00:00 +0000",
y: 0
},
{
x: "Thu, 23 Sep 2021 00:00:00 +0000",
y: 0
},
{
x: "Fri, 24 Sep 2021 00:00:00 +0000",
y: 0
},
{
x: "Sat, 25 Sep 2021 00:00:00 +0000",
y: 0.7
},
{
x: "Sun, 26 Sep 2021 00:00:00 +0000",
y: 0.76
},
{
x: "Mon, 27 Sep 2021 00:00:00 +0000",
y: 0.56
},
{
x: "Tue, 28 Sep 2021 00:00:00 +0000",
y: 0.71
}
],
fill: true,
borderColor: "#B6BDE7",
backgroundColor: "rgba(182, 189, 231, 0.3)",
tension: ".4"
}
]
},
{
datasets: [
{
label: "精準興趣-金額（USD）",
data: [
{
x: "Tue, 21 Sep 2021 00:00:00 +0000",
y: 0.7
},
{
x: "Wed, 22 Sep 2021 00:00:00 +0000",
y: 0
},
{
x: "Thu, 23 Sep 2021 00:00:00 +0000",
y: 0
},
{
x: "Fri, 24 Sep 2021 00:00:00 +0000",
y: 0
},
{
x: "Sat, 25 Sep 2021 00:00:00 +0000",
y: 0.66
},
{
x: "Sun, 26 Sep 2021 00:00:00 +0000",
y: 0.59
},
{
x: "Mon, 27 Sep 2021 00:00:00 +0000",
y: 0.77
},
{
x: "Tue, 28 Sep 2021 00:00:00 +0000",
y: 0.64
}
],
fill: true,
borderColor: "#B6BDE7",
backgroundColor: "rgba(182, 189, 231, 0.3)",
tension: ".4"
}
]
},
{
datasets: [
{
label: "精準興趣-比率（%）",
data: [
{
x: "Tue, 21 Sep 2021 00:00:00 +0000",
y: 16
},
{
x: "Wed, 22 Sep 2021 00:00:00 +0000",
y: 0
},
{
x: "Thu, 23 Sep 2021 00:00:00 +0000",
y: 0
},
{
x: "Fri, 24 Sep 2021 00:00:00 +0000",
y: 0
},
{
x: "Sat, 25 Sep 2021 00:00:00 +0000",
y: 3.03
},
{
x: "Sun, 26 Sep 2021 00:00:00 +0000",
y: 4.41
},
{
x: "Mon, 27 Sep 2021 00:00:00 +0000",
y: 3.67
},
{
x: "Tue, 28 Sep 2021 00:00:00 +0000",
y: 20
}
],
fill: true,
borderColor: "#B6BDE7",
backgroundColor: "rgba(182, 189, 231, 0.3)",
tension: ".4"
}
]
},
{
datasets: [
{
label: "精準興趣-金額（USD）",
data: [
{
x: "Tue, 21 Sep 2021 00:00:00 +0000",
y: 4.37
},
{
x: "Wed, 22 Sep 2021 00:00:00 +0000",
y: 0
},
{
x: "Thu, 23 Sep 2021 00:00:00 +0000",
y: 0
},
{
x: "Fri, 24 Sep 2021 00:00:00 +0000",
y: 0
},
{
x: "Sat, 25 Sep 2021 00:00:00 +0000",
y: 21.79
},
{
x: "Sun, 26 Sep 2021 00:00:00 +0000",
y: 13.31
},
{
x: "Mon, 27 Sep 2021 00:00:00 +0000",
y: 21.07
},
{
x: "Tue, 28 Sep 2021 00:00:00 +0000",
y: 3.2
}
],
fill: true,
borderColor: "#B6BDE7",
backgroundColor: "rgba(182, 189, 231, 0.3)",
tension: ".4"
}
]
}
],
      records: [],
      loading: false,
      filters: {
        global: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS
        },
        campaign_name: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
        },
        status: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
        },
        report: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
        },
        active: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
        },
        updatedDate: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }]
        },
        pageInfo: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
        }
      }
    };
  },
  // created() {
  //   axios
  //     .post('https://www.autoturn.net/api/campaign_list.php', Qs.stringify({
  //       s_code: this.$route.params.id,
  //       adaccount_id: this.$route.params.adaccount_id,
  //     }))
  //     .then((response) => {
  //   //  console.log(response.data);
  //       if(response.data.status == 'success'){
  //         this.records = response.data.return_data
  //       }
  //     });
  // },
  watch:{
    viewDatalist(v){
      // console.log('table viewDatalist');
      // console.log(v);

      this.records = v
    }
  },
  methods: {
    handleClickOpen(e, id, status, adaccountid) {
      // console.log(e+':'+id+status);

      if(status == '執行中' || status == '执行中' || status == 'in execution' || status == '已暫停' || status == '已暂停' || status == 'Paused' || status == '已結束' || status == 'over'){
        this.toggle(e)

        axios
          .post('https://www.autoturn.net/api/campaign_item_chart.php', Qs.stringify({
            s_code: this.$route.params.id,
            id: id,
          }))
          .then((response) => {
            // console.log(response.data);
            if(response.data.status == 'success'){
              // this.records = response.data.return_data

              this.label = response.data.chart_panel
              this.tableData = response.data.info_data
              this.lineStylesData = response.data.return_data

              this.chartCampaignId = id
              this.chartCampaignAdaccountId = adaccountid

              // console.log('tableData');
              // console.log(this.tableData);
              // console.log('lineStylesData');
              // console.log(this.lineStylesData);

              this.fin = true
            }
          });
      }
    },
    toggle(event) {
      // console.log('toggle:'+event)
      this.$refs.previewPanel.toggle(event)

      if(this.fin == true){
        this.fin = false
      }
    },
    campaignActive(id, type, daily_budget, budget_increase, name, adaccount_id, total_budget, Target_AD, Target_CT, sub_campaigns){
  //  console.log('id:'+id+' | type:'+type+' | daily_budget:'+daily_budget+' | budget_increase:'+budget_increase+' | name:'+name+' | adaccount_id:'+adaccount_id+' | total_budget:'+total_budget+' | Target_AD:'+Target_AD);

      // console.log('selecdedCurrency:'+this.selecdedCurrency);

      let currency = this.selecdedCurrency;
      let member_hash = this.$route.params.id;

      axios
        .post('https://www.autoturn.net/api/campaign_member_status.php', Qs.stringify({
          s_code: member_hash,
          route_type: this.$route.params.type,
          active: type,
        }))
        .then((caResponse) => {

          if(caResponse.data.status == 'error'){
            if(caResponse.data.type == 2){
              Swal.fire({
                icon: caResponse.data.status,
                title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['error']['swal_title'],
                text: caResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['error']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  this.allPageLoading = true
                  window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  this.allPageLoading = true
                  window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                }
              })
            } else if(caResponse.data.type == 3){
              Swal.fire({
                icon: caResponse.data.status,
                title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['error']['swal_title'],
                text: caResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['error']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  this.allPageLoading = true
                  window.location.href = "https://private.autoturn.net/f/"+member_hash;
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  this.allPageLoading = true
                  window.location.href = "https://private.autoturn.net/f/"+member_hash;
                }
              })
            } else {
              Swal.fire(
                        this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['error']['swal_title'],
                        caResponse.data.info,
                        caResponse.data.status
                      )
            }
          }

          if(caResponse.data.status == 'warning'){
            Swal.fire({
              icon: 'warning',
              title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['swal_title'],
              text: caResponse.data.info,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['confirm_button']
              // denyButtonText: `Don't save`,
            }).then((result) => {
              if(type == 'edit'){
                if(this.fromAccountSelect == 'facebook'){
                  window.location.href = "https://private.autoturn.net/event/f/"+member_hash+"/"+adaccount_id+"/"+id;
                } else {
                  window.location.href = "https://private.autoturn.net/event-tiktok/t/"+member_hash+"/"+adaccount_id+"/"+id;
                }
              }

              if(type == 'copy'){
                Swal.fire({
                  title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['copy']['swal_title']+"「"+name+"」",
                  html: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['copy']['swal_text'],
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['copy']['yes_button'],
                  cancelButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['copy']['no_button'],
                }).then((result) => {
                  if (result.isConfirmed) {
                    // console.log(this.$route.params.id);
                    axios
                      .post('https://www.autoturn.net/api/campaign_copy.php', Qs.stringify({
                        s_code: member_hash,
                        campaign_id: id,
                      }))
                      .then((caResponse) => {
                        // console.log('caResponse:'+caResponse.data.return_data);
                        // this.$swal(caResponse.data.info);
                        Swal.fire({
                          icon: caResponse.data.status,
                          title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['copy']['swal_title']+"「"+name+"」",
                          text: caResponse.data.info,
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['copy']['confirm_button'],
                          // denyButtonText: `Don't save`,
                        }).then((result) => {
                          if (result.isConfirmed) {
                            // Swal.fire('Saved!', '', 'success')
                            this.allPageLoading = true
                            window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                          } else if (result.isDenied) {
                            // Swal.fire('Changes are not saved', '', 'info')
                            this.allPageLoading = true
                            window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                          }
                        })
                      });
                  }
                })
              }

              if(type == 'chart'){
                window.location.href = "https://private.autoturn.net/report/f/"+member_hash+"/"+adaccount_id+"/"+id;
              }

              if(type == 'pause'){
                Swal.fire({
                  title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['pause']['swal_title']+"「"+name+"」",
                  html: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['pause']['swal_text'],
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['pause']['yes_button'],
                  cancelButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['pause']['no_button'],
                }).then((result) => {
                  if (result.isConfirmed) {
                    // console.log(this.$route.params.id);
                    axios
                      .post('https://www.autoturn.net/api/campaign_stop.php', Qs.stringify({
                        s_code: member_hash,
                        campaign_id: id,
                      }))
                      .then((caResponse) => {
                        // console.log('caResponse:'+caResponse.data.return_data);
                        // this.$swal(caResponse.data.info);
                        Swal.fire({
                          icon: caResponse.data.status,
                          title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['pause']['swal_title']+"「"+name+"」",
                          text: caResponse.data.info,
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['pause']['confirm_button'],
                          // denyButtonText: `Don't save`,
                        }).then((result) => {
                          if (result.isConfirmed) {
                            // Swal.fire('Saved!', '', 'success')
                            this.allPageLoading = true
                            window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                          } else if (result.isDenied) {
                            // Swal.fire('Changes are not saved', '', 'info')
                            this.allPageLoading = true
                            window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                          }
                        })
                      });
                  }
                })
              }

              if(type == 'delete'){
                Swal.fire({
                  title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['delete']['swal_title']+"「"+name+"」",
                  html: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['delete']['swal_text'],
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['delete']['yes_button'],
                  cancelButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['delete']['no_button'],
                }).then((result) => {
                  if (result.isConfirmed) {
                    // console.log(this.$route.params.id);
                    axios
                      .post('https://www.autoturn.net/api/campaign_delete.php', Qs.stringify({
                        s_code: member_hash,
                        campaign_id: id,
                      }))
                      .then((caResponse) => {
                        // console.log('caResponse:'+caResponse.data.return_data);
                        // this.$swal(caResponse.data.info);
                        Swal.fire({
                          icon: caResponse.data.status,
                          title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['delete']['swal_title']+"「"+name+"」",
                          text: caResponse.data.info,
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['delete']['confirm_button'],
                          // denyButtonText: `Don't save`,
                        }).then((result) => {
                          if (result.isConfirmed) {
                            // Swal.fire('Saved!', '', 'success')
                            this.allPageLoading = true
                            window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                          } else if (result.isDenied) {
                            // Swal.fire('Changes are not saved', '', 'info')
                            this.allPageLoading = true
                            window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                          }
                        })
                      });
                  }
                })
              }

              if(type == 'play'){
                Swal.fire({
                  title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['play']['swal_title']+"「"+name+"」",
                  html: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['play']['swal_text'],
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['play']['yes_button'],
                  cancelButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['play']['no_button'],
                }).then((result) => {
                  if (result.isConfirmed) {
                    // console.log(this.$route.params.id);
                    axios
                      .post('https://www.autoturn.net/api/campaign_restart.php', Qs.stringify({
                        s_code: member_hash,
                        campaign_id: id,
                      }))
                      .then((caResponse) => {
                        // console.log('caResponse:'+caResponse.data.return_data);
                        // this.$swal(caResponse.data.info);
                        Swal.fire({
                          icon: caResponse.data.status,
                          title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['play']['swal_title']+"「"+name+"」",
                          text: caResponse.data.info,
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['play']['confirm_button'],
                          // denyButtonText: `Don't save`,
                        }).then((result) => {
                          if (result.isConfirmed) {
                            // Swal.fire('Saved!', '', 'success')
                            this.allPageLoading = true
                            window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                          } else if (result.isDenied) {
                            // Swal.fire('Changes are not saved', '', 'info')
                            this.allPageLoading = true
                            window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                          }
                        })
                      });
                  }
                })
              }

              if(type == 'browse'){
                if(this.fromAccountSelect == 'facebook'){
                  window.location.href = "https://private.autoturn.net/event-browse/f/"+member_hash+"/"+adaccount_id+"/"+id;
                } else {
                  window.location.href = "https://private.autoturn.net/event-browse-tiktok/t/"+member_hash+"/"+adaccount_id+"/"+id;
                }
              }

              if(type == 'release'){
                let addition_text = '（'+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['addition_text']+'：<span style="color:red; font-weight:bold;">'+budget_increase+'%</span>）';
                if(Target_AD == true){
                  addition_text = '';
                }
                let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(budget_increase/100)));
                let campaignInfo = this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['swal_text_total_budget_a']+"<br/>"+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['swal_text_total_budget_c']+"</span>"+addition_text;
                if(total_budget != 0){
                  two_week_budget = total_budget;
                  campaignInfo = this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['swal_text_not_total_budget_a']+"<br/>"+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['swal_text_not_total_budget_c']+"</span>"+addition_text;
                }

            //  console.log('this.parentMemberInfo');
            //  console.log(this.parentMemberInfo);

                if(this.parentMemberInfo.source == 6 && (this.parentMemberInfo.plan_id == 1 || this.parentMemberInfo.status == 's')){
                  Swal.fire({
                    icon: 'warning',
                    title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['class_check_release_permissions']['swal_title'],
                    text: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['class_check_release_permissions']['swal_text'],
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText:this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['class_check_release_permissions']['confirm_button'],
                    // denyButtonText: `Don't save`,
                  }).then((result) => {

                  })
                } else {
                  let _tableContent = campaignInfo + "<br/><br/>"+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['swal_text_a']+"<span style='color:red;'>"+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['swal_text_b']+"</span>"+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['swal_text_c'];

                  if(Target_CT == '1'){
                    _tableContent = '<div style="display: flex; flex-wrap: wrap; width: 600px; border: 1px solid #ccc;">\
                                            <div style="display: flex; width: 100%;">\
                                              <div style="width: 33.33%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px; background-color: #CBD5E1;">階段</div>\
                                              <div style="width: 33.33%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px; background-color: #CBD5E1;">目標</div>\
                                              <div style="width: 33.33%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px; background-color: #CBD5E1;">預算</div>\
                                            </div>';

                    for(let j = 0; j < sub_campaigns.length; j++){
                      let _methodName = sub_campaigns[j].subset_method;
                      let _objectiveName = sub_campaigns[j].campaign_objective;
                      let _budget = '<b>'+sub_campaigns[j].daily_budget+'</b><span style="font-size:14px; margin-left:4px; margin-top:4px;">'+currency+'/day</span>';

                      _tableContent += '<div style="display: flex; width: 100%;">\
                                          <div style="width: 33.33%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px;">'+_methodName+'</div>\
                                          <div style="width: 33.33%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px;">'+_objectiveName+'</div>\
                                          <div style="width: 33.33%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px;">'+_budget+'</div>\
                                        </div>';
                    }

                    _tableContent += '</div>';
                    _tableContent += "<b style='color:red;'>請勿在Facebook廣告後台修改行銷活動設定、受眾資料(AutoTurn開頭)，<br/>若修改到系統便會暫停自動化</b><br/>"+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['swal_text_c'];
                  }
                    Swal.fire({
                    title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['swal_title']+"「"+name+"」",
                    html: _tableContent,
                    icon: 'warning',
                    showCancelButton: true,
                    width: 'auto', // 可選：根據內容自動調整寬度
                    padding: '1em',
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['yes_button'],
                    cancelButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['no_button'],
                  }).then((result) => {
                    if (result.isConfirmed) {
                      // console.log('this.$route.params.id:');
                      // console.log(this.$route.params.id);
                      // console.log('id:');
                      // console.log(id);

                      this.releaseType = true
                      this.style = 'z-index:100;';
                      this.releasePercent = 5;
                      let status = 1;
                      let num = 0;
                      var bar5 = new ldBar("#releaseFill");
                      bar5.set(this.releasePercent);

                      axios
                        .post('https://www.autoturn.net/api/campaign_release.php', Qs.stringify({
                          s_code: member_hash,
                          campaign_id: id,
                        }))
                        .then((caResponse) => {
                          // console.log('caResponse:'+caResponse.data.return_data);
                          if(caResponse.data.status == 'success'){
                        //  console.log('開始進度條');
                            //進行進度條
                        //  console.log('發佈莞成，開始跑進度條');
                            setInterval( () => {
                              num++;
                              if(num < 1200){
                                // console.log('num:'+num);
                                // console.log(this.releaseType);

                                if(this.releaseType == true){
                                  axios
                                    .post('https://www.autoturn.net/api/campaign_states.php', Qs.stringify({
                                      s_code: member_hash,
                                      adaccount_id: adaccount_id,
                                      campaign_id: id,
                                    }))
                                    .then((csResponse) => {
                                      // console.log('csResponse:'+csResponse.data.return_data);
                                      //進行進度條
                                      if(status == 1){
                                        if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                          this.releaseType = false
                                          status = 0;

                                          let _tableContent = this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['info_state_failure']['swal_html_a']+csResponse.data.return_data.info_text+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['info_state_failure']['swal_html_b'];
                                          let useTimer = 5000;

                                          if(Target_CT == '1'){
                                            _tableContent = '發布失敗，請參考下列各階段的發布結果，來進行調整：<br/>'+'<div style="display: flex; flex-wrap: wrap; width: 600px; border: 1px solid #ccc;">\
                                                                    <div style="display: flex; width: 100%;">\
                                                                      <div style="width: 33.33%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px; background-color: #CBD5E1;">階段名稱</div>\
                                                                      <div style="width: 66.67%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px; background-color: #CBD5E1;">發布結果</div>\
                                                                    </div>';

                                            for(let j = 0; j < sub_campaigns.length; j++){
                                              let _methodName = sub_campaigns[j].subset_method;
                                              let _releaseContent = csResponse.data.sub_campaigns[sub_campaigns[j].sr_i].current;
                                              let stageIndex = j;
                                              let stageTitle = _methodName;
                                              if(sub_campaigns[0].method != 'META_TEST'){
                                                stageIndex = j + parseInt(1);
                                                stageTitle = '階段 '+stageIndex+'：'+_methodName;
                                              } else {
                                                if(j != 0){
                                                  stageTitle = '階段 '+stageIndex+'：'+_methodName;
                                                }
                                              }

                                              _tableContent += '<div style="display: flex; width: 100%;">\
                                                                  <div style="width: 33.33%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px;">'+stageTitle+'</div>\
                                                                  <div style="width: 66.67%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px;">'+_releaseContent+'</div>\
                                                                </div>';
                                            }

                                            _tableContent += '</div>';
                                            useTimer = 60000;
                                          }

                                          Swal.fire({
                                            icon: 'error',
                                            title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['info_state_failure']['swal_title'],
                                            html: _tableContent,
                                            showDenyButton: false,
                                            showCancelButton: false,
                                            width: 'auto',
                                            padding: '1em',
                                            confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['info_state_failure']['confirm_button'],
                                            timer: useTimer
                                            // denyButtonText: `Don't save`,
                                          }).then((result) => {
                                            /* Read more about isConfirmed, isDenied below */
                                            if (result.isConfirmed) {
                                              // Swal.fire('Saved!', '', 'success')
                                              this.allPageLoading = true
                                              window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                            } else if (result.isDenied) {
                                              // Swal.fire('Changes are not saved', '', 'info')
                                              this.allPageLoading = true
                                              window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                            }

                                            if (result.dismiss === Swal.DismissReason.timer) {
                                              this.allPageLoading = true
                                              window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                            }
                                          })
                                        } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                          status = 0;

                                          let postData = {adaccount_id: this.$route.params.adaccount_id};
                                          let codeHash = ['de', 'di']

                                          const data = new URLSearchParams();
                                          data.append('s_code', this.$route.params.id);
                                          data.append('post_data', JSON.stringify(postData));
                                          data.append('code_hash', JSON.stringify(codeHash));
                                          data.append('update_type', true);

                                          // 發送請求
                                          navigator.sendBeacon(
                                            'https://www.autoturn.net/api/update_cache.php',
                                            data
                                          );

                                          axios
                                            .post('https://www.autoturn.net/api/data/campaign_creative_optimize_update.php', Qs.stringify({
                                              s_code: member_hash,
                                              id: id,
                                            }))
                                            .then((response) => {
                                              axios
                                                .get('https://www.autoturn.net/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+id)
                                                .then((csResponse) => {
                                                  this.releaseType = false

                                                  Swal.fire({
                                                    icon: 'success',
                                                    title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['info_state_success']['swal_title'],
                                                    text: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['info_state_success']['swal_html'],
                                                    showDenyButton: false,
                                                    showCancelButton: false,
                                                    confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['info_state_success']['confirm_button'],
                                                    timer: 5000
                                                    // denyButtonText: `Don't save`,
                                                  }).then((result) => {
                                                    /* Read more about isConfirmed, isDenied below */
                                                    if (result.isConfirmed) {
                                                      // Swal.fire('Saved!', '', 'success')
                                                      this.allPageLoading = true
                                                      window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                    } else if (result.isDenied) {
                                                      // Swal.fire('Changes are not saved', '', 'info')
                                                      this.allPageLoading = true
                                                      window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                    }

                                                    if (result.dismiss === Swal.DismissReason.timer) {
                                                      this.allPageLoading = true
                                                      window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                    }
                                                  })
                                                });
                                            });
                                        } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                          this.releaseType = false
                                          status = 0;

                                          let _tableContent = this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['state_failure']['swal_html_a']+csResponse.data.return_data.info_text+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['state_failure']['swal_html_b'];
                                          let useTimer = 5000;

                                          if(Target_CT == '1'){
                                            _tableContent = '發布失敗，請參考下列各階段的發布結果，來進行調整：<br/>'+'<div style="display: flex; flex-wrap: wrap; width: 600px; border: 1px solid #ccc;">\
                                                                    <div style="display: flex; width: 100%;">\
                                                                      <div style="width: 33.33%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px; background-color: #CBD5E1;">階段名稱</div>\
                                                                      <div style="width: 66.67%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px; background-color: #CBD5E1;">發布結果</div>\
                                                                    </div>';

                                            for(let j = 0; j < sub_campaigns.length; j++){
                                              let _methodName = sub_campaigns[j].subset_method;
                                              let _releaseContent = csResponse.data.sub_campaigns[sub_campaigns[j].sr_i].current;
                                              let stageIndex = j;
                                              let stageTitle = _methodName;
                                              if(sub_campaigns[0].method != 'META_TEST'){
                                                stageIndex = j + parseInt(1);
                                                stageTitle = '階段 '+stageIndex+'：'+_methodName;
                                              } else {
                                                if(j != 0){
                                                  stageTitle = '階段 '+stageIndex+'：'+_methodName;
                                                }
                                              }

                                              _tableContent += '<div style="display: flex; width: 100%;">\
                                                                  <div style="width: 33.33%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px;">'+stageTitle+'</div>\
                                                                  <div style="width: 66.67%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px;">'+_releaseContent+'</div>\
                                                                </div>';
                                            }

                                            _tableContent += '</div>';
                                            useTimer = 60000;
                                          }

                                          Swal.fire({
                                            icon: 'error',
                                            title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['state_failure']['swal_title'],
                                            html: _tableContent,
                                            showDenyButton: false,
                                            showCancelButton: false,
                                            width: 'auto',
                                            padding: '1em',
                                            confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['state_failure']['confirm_button'],
                                            useTimer: 5000
                                            // denyButtonText: `Don't save`,
                                          }).then((result) => {
                                            /* Read more about isConfirmed, isDenied below */
                                            if (result.isConfirmed) {
                                              // Swal.fire('Saved!', '', 'success')
                                              this.allPageLoading = true
                                              window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                            } else if (result.isDenied) {
                                              // Swal.fire('Changes are not saved', '', 'info')
                                              this.allPageLoading = true
                                              window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                            }

                                            if (result.dismiss === Swal.DismissReason.timer) {
                                              this.allPageLoading = true
                                              window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                            }
                                          })
                                        } else {
                                          this.releaseText = csResponse.data.return_data.info_text
                                          this.releasePercent = csResponse.data.return_data.info_pct

                                          bar5.set(this.releasePercent);
                                          // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                          // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                          // console.log('this.releaseText:'+this.releaseText);
                                          // console.log('this.releasePercent:'+this.releasePercent);

                                          if(csResponse.data.return_data.info_pct == 100){
                                            this.releaseType = false
                                            this.style = 'z-index:-1;';
                                            bar5.set(0);
                                            status = 0;
                                          }
                                        }
                                      }
                                    });
                                }
                              } else {
                                Swal.fire({
                                  icon: 'warning',
                                  title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['else']['swal_title'],
                                  text: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['else']['swal_html'],
                                  showDenyButton: false,
                                  showCancelButton: false,
                                  confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['else']['confirm_button'],
                                  timer: 1000
                                  // denyButtonText: `Don't save`,
                                }).then((result) => {
                                  /* Read more about isConfirmed, isDenied below */
                                  if (result.isConfirmed) {
                                    // Swal.fire('Saved!', '', 'success')
                                    this.allPageLoading = true
                                    window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                  } else if (result.isDenied) {
                                    // Swal.fire('Changes are not saved', '', 'info')
                                    this.allPageLoading = true
                                    window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                  }

                                  if (result.dismiss === Swal.DismissReason.timer) {
                                    this.allPageLoading = true
                                    window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                  }
                                })
                              }
                            }, 3000);
                          } else {
                            Swal.fire({
                              icon: 'error',
                              title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['state_failure']['swal_title'],
                              text: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['state_failure']['swal_html_a']+csResponse.data.return_data.info_text+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['state_failure']['swal_html_b'],
                              showDenyButton: false,
                              showCancelButton: false,
                              confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['state_failure']['confirm_button'],
                              timer: 5000
                              // denyButtonText: `Don't save`,
                            }).then((result) => {
                              /* Read more about isConfirmed, isDenied below */
                              if (result.isConfirmed) {
                                // Swal.fire('Saved!', '', 'success')
                                this.allPageLoading = true
                                window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                              } else if (result.isDenied) {
                                // Swal.fire('Changes are not saved', '', 'info')
                                this.allPageLoading = true
                                window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                              }

                              if (result.dismiss === Swal.DismissReason.timer) {
                                this.allPageLoading = true
                                window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                              }
                            })
                          }
                        });
                    }
                  })
                }

              }
            });
          }

          if(caResponse.data.status == 'success'){
            if(type == 'edit'){
              if(this.fromAccountSelect == 'facebook'){
                window.location.href = "https://private.autoturn.net/event/f/"+member_hash+"/"+adaccount_id+"/"+id;
              } else {
                window.location.href = "https://private.autoturn.net/event-tiktok/t/"+member_hash+"/"+adaccount_id+"/"+id;
              }
            }

            if(type == 'copy'){
              Swal.fire({
                title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['copy']['swal_title']+"「"+name+"」",
                html: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['copy']['swal_text'],
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['copy']['yes_button'],
                cancelButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['copy']['no_button'],
              }).then((result) => {
                if (result.isConfirmed) {
                  // console.log(this.$route.params.id);
                  axios
                    .post('https://www.autoturn.net/api/campaign_copy.php', Qs.stringify({
                      s_code: member_hash,
                      campaign_id: id,
                    }))
                    .then((caResponse) => {
                      // console.log('caResponse:'+caResponse.data.return_data);
                      // this.$swal(caResponse.data.info);
                      Swal.fire({
                        icon: caResponse.data.status,
                        title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['copy']['swal_title']+"「"+name+"」",
                        text: caResponse.data.info,
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['copy']['confirm_button'],
                        // denyButtonText: `Don't save`,
                      }).then((result) => {
                        if (result.isConfirmed) {
                          // Swal.fire('Saved!', '', 'success')
                          this.allPageLoading = true
                          window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                        } else if (result.isDenied) {
                          // Swal.fire('Changes are not saved', '', 'info')
                          this.allPageLoading = true
                          window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                        }
                      })
                    });
                }
              })
            }

            if(type == 'chart'){
              window.location.href = "https://private.autoturn.net/report/f/"+member_hash+"/"+adaccount_id+"/"+id;
            }

            if(type == 'pause'){
              Swal.fire({
                title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['pause']['swal_title']+"「"+name+"」",
                html: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['pause']['swal_text'],
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['pause']['yes_button'],
                cancelButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['pause']['no_button'],
              }).then((result) => {
                if (result.isConfirmed) {
                  // console.log(this.$route.params.id);
                  axios
                    .post('https://www.autoturn.net/api/campaign_stop.php', Qs.stringify({
                      s_code: member_hash,
                      campaign_id: id,
                    }))
                    .then((caResponse) => {
                      // console.log('caResponse:'+caResponse.data.return_data);
                      // this.$swal(caResponse.data.info);
                      Swal.fire({
                        icon: caResponse.data.status,
                        title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['pause']['swal_title']+"「"+name+"」",
                        text: caResponse.data.info,
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['pause']['confirm_button'],
                        // denyButtonText: `Don't save`,
                      }).then((result) => {
                        if (result.isConfirmed) {
                          // Swal.fire('Saved!', '', 'success')
                          this.allPageLoading = true
                          window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                        } else if (result.isDenied) {
                          // Swal.fire('Changes are not saved', '', 'info')
                          this.allPageLoading = true
                          window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                        }
                      })
                    });
                }
              })
            }

            if(type == 'delete'){
              Swal.fire({
                title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['delete']['swal_title']+"「"+name+"」",
                html: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['delete']['swal_text'],
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['delete']['yes_button'],
                cancelButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['delete']['no_button'],
              }).then((result) => {
                if (result.isConfirmed) {
                  // console.log(this.$route.params.id);
                  axios
                    .post('https://www.autoturn.net/api/campaign_delete.php', Qs.stringify({
                      s_code: member_hash,
                      campaign_id: id,
                    }))
                    .then((caResponse) => {
                      // console.log('caResponse:'+caResponse.data.return_data);
                      // this.$swal(caResponse.data.info);
                      Swal.fire({
                        icon: caResponse.data.status,
                        title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['delete']['swal_title']+"「"+name+"」",
                        text: caResponse.data.info,
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['delete']['confirm_button'],
                        // denyButtonText: `Don't save`,
                      }).then((result) => {
                        if (result.isConfirmed) {
                          // Swal.fire('Saved!', '', 'success')
                          this.allPageLoading = true
                          window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                        } else if (result.isDenied) {
                          // Swal.fire('Changes are not saved', '', 'info')
                          this.allPageLoading = true
                          window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                        }
                      })
                    });
                }
              })
            }

            if(type == 'play'){
              Swal.fire({
                title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['play']['swal_title']+"「"+name+"」",
                html: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['play']['swal_text'],
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['play']['yes_button'],
                cancelButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['play']['no_button'],
              }).then((result) => {
                if (result.isConfirmed) {
                  // console.log(this.$route.params.id);
                  axios
                    .post('https://www.autoturn.net/api/campaign_restart.php', Qs.stringify({
                      s_code: member_hash,
                      campaign_id: id,
                    }))
                    .then((caResponse) => {
                      // console.log('caResponse:'+caResponse.data.return_data);
                      // this.$swal(caResponse.data.info);
                      Swal.fire({
                        icon: caResponse.data.status,
                        title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['play']['swal_title']+"「"+name+"」",
                        text: caResponse.data.info,
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['play']['confirm_button'],
                        // denyButtonText: `Don't save`,
                      }).then((result) => {
                        if (result.isConfirmed) {
                          // Swal.fire('Saved!', '', 'success')
                          this.allPageLoading = true
                          window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                        } else if (result.isDenied) {
                          // Swal.fire('Changes are not saved', '', 'info')
                          this.allPageLoading = true
                          window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                        }
                      })
                    });
                }
              })
            }

            if(type == 'browse'){
              if(this.fromAccountSelect == 'facebook'){
                window.location.href = "https://private.autoturn.net/event-browse/f/"+member_hash+"/"+adaccount_id+"/"+id;
              } else {
                window.location.href = "https://private.autoturn.net/event-browse-tiktok/t/"+member_hash+"/"+adaccount_id+"/"+id;
              }
            }

            if(type == 'release'){
              let addition_text = '（'+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['addition_text']+'：<span style="color:red; font-weight:bold;">'+budget_increase+'%</span>）';
              if(Target_AD == true){
                addition_text = '';
              }
              let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(budget_increase/100)));
              let campaignInfo = this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['swal_text_total_budget_a']+"<br/>"+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['swal_text_total_budget_c']+"</span>"+addition_text;
              if(total_budget != 0){
                two_week_budget = total_budget;
                campaignInfo = this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['swal_text_not_total_budget_a']+"<br/>"+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['swal_text_not_total_budget_c']+"</span>"+addition_text;
              }

          //  console.log('this.parentMemberInfo');
          //  console.log(this.parentMemberInfo);

              if(this.parentMemberInfo.source == 6 && (this.parentMemberInfo.plan_id == 1 || this.parentMemberInfo.status == 's')){
                Swal.fire({
                  icon: 'warning',
                  title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['class_check_release_permissions']['swal_title'],
                  text: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['class_check_release_permissions']['swal_text'],
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText:this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['class_check_release_permissions']['confirm_button'],
                  // denyButtonText: `Don't save`,
                }).then((result) => {

                })
              } else {
                let _tableContent = campaignInfo + "<br/><br/>"+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['swal_text_a']+"<span style='color:red;'>"+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['swal_text_b']+"</span>"+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['swal_text_c'];

                if(Target_CT == '1'){
                  _tableContent = '<div style="display: flex; flex-wrap: wrap; width: 600px; border: 1px solid #ccc;">\
                                          <div style="display: flex; width: 100%;">\
                                            <div style="width: 33.33%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px; background-color: #CBD5E1;">階段</div>\
                                            <div style="width: 33.33%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px; background-color: #CBD5E1;">目標</div>\
                                            <div style="width: 33.33%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px; background-color: #CBD5E1;">預算</div>\
                                          </div>';

                  for(let j = 0; j < sub_campaigns.length; j++){
                    let _methodName = sub_campaigns[j].subset_method;
                    let _objectiveName = sub_campaigns[j].campaign_objective;
                    let _budget = '<b>'+sub_campaigns[j].daily_budget+'</b><span style="font-size:14px; margin-left:4px; margin-top:4px;">'+currency+'/day</span>';

                    _tableContent += '<div style="display: flex; width: 100%;">\
                                        <div style="width: 33.33%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px;">'+_methodName+'</div>\
                                        <div style="width: 33.33%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px;">'+_objectiveName+'</div>\
                                        <div style="width: 33.33%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px;">'+_budget+'</div>\
                                      </div>';
                  }

                  _tableContent += '</div>';
                  _tableContent += "<b style='color:red;'>請勿在Facebook廣告後台修改行銷活動設定、受眾資料(AutoTurn開頭)，<br/>若修改到系統便會暫停自動化</b><br/>"+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['swal_text_c'];
                }

                Swal.fire({
                  title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['swal_title']+"「"+name+"」",
                  html: _tableContent,
                  icon: 'warning',
                  showCancelButton: true,
                  width: 'auto', // 可選：根據內容自動調整寬度
                  padding: '1em',
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['yes_button'],
                  cancelButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['no_button'],
                }).then((result) => {
                  if (result.isConfirmed) {
                    // console.log('this.$route.params.id:');
                    // console.log(this.$route.params.id);
                    // console.log('id:');
                    // console.log(id);

                    this.releaseType = true
                    this.style = 'z-index:100;';
                    this.releasePercent = 5;
                    let status = 1;
                    let num = 0;
                    var bar5 = new ldBar("#releaseFill");
                    bar5.set(this.releasePercent);

                    axios
                      .post('https://www.autoturn.net/api/campaign_release.php', Qs.stringify({
                        s_code: member_hash,
                        campaign_id: id,
                      }))
                      .then((caResponse) => {
                        // console.log('caResponse:'+caResponse.data.return_data);
                        if(caResponse.data.status == 'success'){
                      //  console.log('進度條');
                          //進行進度條
                      //  console.log('發佈莞成，開始跑進度條');
                          setInterval( () => {
                            num++;
                            if(num < 1200){
                              // console.log('num:'+num);
                              // console.log(this.releaseType);

                              if(this.releaseType == true){
                                axios
                                  .post('https://www.autoturn.net/api/campaign_states.php', Qs.stringify({
                                    s_code: member_hash,
                                    adaccount_id: adaccount_id,
                                    campaign_id: id,
                                  }))
                                  .then((csResponse) => {
                                    // console.log('csResponse:'+csResponse.data.return_data);
                                    //進行進度條
                                    if(status == 1){
                                      if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                        this.releaseType = false
                                        status = 0;

                                        let _tableContent = this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['info_state_failure']['swal_html_a']+csResponse.data.return_data.info_text+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['info_state_failure']['swal_html_b'];
                                        let useTimer = 5000;

                                        if(Target_CT == '1'){
                                          _tableContent = '發布失敗，請參考下列各階段的發布結果，來進行調整：<br/>'+'<div style="display: flex; flex-wrap: wrap; width: 600px; border: 1px solid #ccc;">\
                                                                  <div style="display: flex; width: 100%;">\
                                                                    <div style="width: 33.33%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px; background-color: #CBD5E1;">階段名稱</div>\
                                                                    <div style="width: 66.67%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px; background-color: #CBD5E1;">發布結果</div>\
                                                                  </div>';

                                          for(let j = 0; j < sub_campaigns.length; j++){
                                            let _methodName = sub_campaigns[j].subset_method;
                                            let _releaseContent = csResponse.data.sub_campaigns[sub_campaigns[j].sr_i].current;
                                            let stageIndex = j;
                                            let stageTitle = _methodName;
                                            if(sub_campaigns[0].method != 'META_TEST'){
                                              stageIndex = j + parseInt(1);
                                              stageTitle = '階段 '+stageIndex+'：'+_methodName;
                                            } else {
                                              if(j != 0){
                                                stageTitle = '階段 '+stageIndex+'：'+_methodName;
                                              }
                                            }

                                            _tableContent += '<div style="display: flex; width: 100%;">\
                                                                <div style="width: 33.33%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px;">'+stageTitle+'</div>\
                                                                <div style="width: 66.67%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px;">'+_releaseContent+'</div>\
                                                              </div>';
                                          }

                                          _tableContent += '</div>';
                                          useTimer = 60000;
                                        }

                                        Swal.fire({
                                          icon: 'error',
                                          title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['info_state_failure']['swal_title'],
                                          html: _tableContent,
                                          showDenyButton: false,
                                          showCancelButton: false,
                                          width: 'auto',
                                          padding: '1em',
                                          confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['info_state_failure']['confirm_button'],
                                          timer: useTimer
                                          // denyButtonText: `Don't save`,
                                        }).then((result) => {
                                          /* Read more about isConfirmed, isDenied below */
                                          let info_text = csResponse.data.return_data.info_text;
                                          let tosStatus = info_text.includes("/leadgen/tos");

                                          if (result.isConfirmed) {
                                            // Swal.fire('Saved!', '', 'success')
                                            this.allPageLoading = true
                                            if(tosStatus == true){
                                              window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
                                            }
                                            window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                          } else if (result.isDenied) {
                                            // Swal.fire('Changes are not saved', '', 'info')
                                            this.allPageLoading = true
                                            if(tosStatus == true){
                                              window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
                                            }
                                            window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                          }

                                          if (result.dismiss === Swal.DismissReason.timer) {
                                            this.allPageLoading = true
                                            if(tosStatus == true){
                                              window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
                                            }
                                            window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                          }
                                        })
                                      } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                        status = 0;

                                        let postData = {adaccount_id: this.$route.params.adaccount_id};
                                        let codeHash = ['de', 'di']

                                        const data = new URLSearchParams();
                                        data.append('s_code', this.$route.params.id);
                                        data.append('post_data', JSON.stringify(postData));
                                        data.append('code_hash', JSON.stringify(codeHash));
                                        data.append('update_type', true);

                                        // 發送請求
                                        navigator.sendBeacon(
                                          'https://www.autoturn.net/api/update_cache.php',
                                          data
                                        );

                                        axios
                                          .post('https://www.autoturn.net/api/data/campaign_creative_optimize_update.php', Qs.stringify({
                                            s_code: member_hash,
                                            id: id,
                                          }))
                                          .then((response) => {
                                            axios
                                              .get('https://www.autoturn.net/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+id)
                                              .then((csResponse) => {
                                                this.releaseType = false

                                                Swal.fire({
                                                  icon: 'success',
                                                  title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['info_state_success']['swal_title'],
                                                  text: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['info_state_success']['swal_html'],
                                                  showDenyButton: false,
                                                  showCancelButton: false,
                                                  confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['info_state_success']['confirm_button'],
                                                  timer: 5000
                                                  // denyButtonText: `Don't save`,
                                                }).then((result) => {
                                                  /* Read more about isConfirmed, isDenied below */
                                                  if (result.isConfirmed) {
                                                    // Swal.fire('Saved!', '', 'success')
                                                    this.allPageLoading = true
                                                    window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                  } else if (result.isDenied) {
                                                    // Swal.fire('Changes are not saved', '', 'info')
                                                    this.allPageLoading = true
                                                    window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                  }

                                                  if (result.dismiss === Swal.DismissReason.timer) {
                                                    this.allPageLoading = true
                                                    window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                                  }
                                                })
                                              });
                                          });
                                      } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                        this.releaseType = false
                                        status = 0;

                                        let _tableContent = this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['state_failure']['swal_html_a']+csResponse.data.return_data.info_text+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['state_failure']['swal_html_b'];
                                        let useTimer = 5000;

                                        if(Target_CT == '1'){
                                          _tableContent = '發布失敗，請參考下列各階段的發布結果，來進行調整：<br/>'+'<div style="display: flex; flex-wrap: wrap; width: 600px; border: 1px solid #ccc;">\
                                                                  <div style="display: flex; width: 100%;">\
                                                                    <div style="width: 33.33%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px; background-color: #CBD5E1;">階段名稱</div>\
                                                                    <div style="width: 66.67%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px; background-color: #CBD5E1;">發布結果</div>\
                                                                  </div>';

                                          for(let j = 0; j < sub_campaigns.length; j++){
                                            let _methodName = sub_campaigns[j].subset_method;
                                            let _releaseContent = csResponse.data.sub_campaigns[sub_campaigns[j].sr_i].current;
                                            let stageIndex = j;
                                            let stageTitle = _methodName;
                                            if(sub_campaigns[0].method != 'META_TEST'){
                                              stageIndex = j + parseInt(1);
                                              stageTitle = '階段 '+stageIndex+'：'+_methodName;
                                            } else {
                                              if(j != 0){
                                                stageTitle = '階段 '+stageIndex+'：'+_methodName;
                                              }
                                            }

                                            _tableContent += '<div style="display: flex; width: 100%;">\
                                                                <div style="width: 33.33%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px;">'+stageTitle+'</div>\
                                                                <div style="width: 66.67%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px;">'+_releaseContent+'</div>\
                                                              </div>';
                                          }

                                          _tableContent += '</div>';
                                          useTimer = 60000;
                                        }

                                        Swal.fire({
                                          icon: 'error',
                                          title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['state_failure']['swal_title'],
                                          html: _tableContent,
                                          showDenyButton: false,
                                          showCancelButton: false,
                                          width: 'auto',
                                          padding: '1em',
                                          confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['state_failure']['confirm_button'],
                                          timer: useTimer
                                          // denyButtonText: `Don't save`,
                                        }).then((result) => {
                                          /* Read more about isConfirmed, isDenied below */
                                          let info_text = csResponse.data.return_data.info_text;
                                          let tosStatus = info_text.includes("/leadgen/tos");

                                          if (result.isConfirmed) {
                                            // Swal.fire('Saved!', '', 'success')
                                            this.allPageLoading = true
                                            if(tosStatus == true){
                                              window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
                                            }
                                            window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                          } else if (result.isDenied) {
                                            // Swal.fire('Changes are not saved', '', 'info')
                                            this.allPageLoading = true
                                            if(tosStatus == true){
                                              window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
                                            }
                                            window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                          }

                                          if (result.dismiss === Swal.DismissReason.timer) {
                                            this.allPageLoading = true
                                            if(tosStatus == true){
                                              window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
                                            }
                                            window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                          }
                                        })
                                      } else {
                                        this.releaseText = csResponse.data.return_data.info_text
                                        this.releasePercent = csResponse.data.return_data.info_pct

                                        bar5.set(this.releasePercent);
                                        // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                        // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                        // console.log('this.releaseText:'+this.releaseText);
                                        // console.log('this.releasePercent:'+this.releasePercent);

                                        if(csResponse.data.return_data.info_pct == 100){
                                          this.releaseType = false
                                          status = 0;
                                        }
                                      }
                                    }
                                  });
                              }
                            } else {
                              Swal.fire({
                                icon: 'warning',
                                title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['else']['swal_title'],
                                text: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['else']['swal_html'],
                                showDenyButton: false,
                                showCancelButton: false,
                                confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['else']['confirm_button'],
                                timer: 1000
                                // denyButtonText: `Don't save`,
                              }).then((result) => {
                                /* Read more about isConfirmed, isDenied below */
                                if (result.isConfirmed) {
                                  // Swal.fire('Saved!', '', 'success')
                                  this.allPageLoading = true
                                  window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                } else if (result.isDenied) {
                                  // Swal.fire('Changes are not saved', '', 'info')
                                  this.allPageLoading = true
                                  window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                }

                                if (result.dismiss === Swal.DismissReason.timer) {
                                  this.allPageLoading = true
                                  window.location.href = "https://private.autoturn.net/events-list/f/"+member_hash+"/"+adaccount_id;
                                }
                              })
                            }
                          }, 3000);
                        }
                      });
                  }
                })

              }

            }
          }

          if(caResponse.data.status == 'login'){
            Swal.fire({
              icon: 'error',
              title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['login']['swal_title'],
              text: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['login']['swal_text'],
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['login']['confirm_button']
              // denyButtonText: `Don't save`,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                // Swal.fire('Saved!', '', 'success')
                // this.allPageLoading = true
                window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
              } else if (result.isDenied) {
                // Swal.fire('Changes are not saved', '', 'info')
                // this.allPageLoading = true
                window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
              }
            })
          }
        });
    },
    onPageCange(event){
      // console.log(event);
    }
  }
};
</script>

<style lang="scss" scoped>

.sub_table {
  display: flex;
  flex-wrap: wrap;
  width: 600px; /* 表格的寬度 */
  border: 1px solid #ccc; /* 表格邊框 */
}
.sub_row {
  display: flex;
  width: 100%;
}
.sub_cell {
  width: 33.33%;
  height: auto; /* 單元格的高度 */
  border: 1px solid #ccc; /* 單元格邊框 */
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 18px 4px;
}
.sub_header {
  background-color: #CBD5E1;
}

/* panel / status-tag / blue / green / red / flag / grey 樣式已由 d2-list-table-card / d2-list-status-tag / d2-list-report-* 全局 CSS 取代 */

.data-txt {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 17px;
  text-align: center;
  color: var(--charcoal, #404040);
}

.small-txt {
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 15px;
  color: var(--slate, #7E7E7E);
}

.overpanel-title {
  padding: 1rem 1rem;
  font-family: PingFang HK;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 17px;
  color: #404040;
}

.close-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #F6F6F6;
  color: #000000;
  width: 2rem;
  height: 2rem;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
  border-radius: 50%;
  position: absolute;
  top: 1.75rem;
  right: 1rem;
  cursor: pointer;
}

</style>